import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { TabComponent } from './tab/tab.component';

@Component({
  templateUrl: 'tabs.html',
  selector: 'tabs'
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  public selectTab(tab: TabComponent): void {
    this.tabs.toArray().forEach(item => item.active = false);
    tab.active = true;
  }

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active);

    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/tabs.component.ts